module.exports = __webpack_public_path__ + "static/img/logo.c08e1cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1